import { errorWrapper } from 'utility/error';

import { apiClient } from './api';

// Uploads a single integration file. We deliberately don't transform the
// FileResponse back into Data.File: the response shape (FileResponse) lacks
// the per-row counts that Data.File needs — the caller refreshes via
// getFiles to pick up the new row with full FileImportSummaryResponse data.
async function uploadFile(args: { tenantId: string; file: File }) {
  const { tenantId, file } = args;

  const apiCall = apiClient.File_UploadFile(
    { File: file, FriendlyFileName: file.name },
    { params: { tenantId } },
  );

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to upload file',
    },
    onSuccess: () => undefined,
  });
}

export { uploadFile };
